import { Typography } from '@mui/material'

import { Maybe } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { StorageImage, User, useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import { SignUpArtistForm, SignUpArtistFormProps } from './SignUpArtistForm'
import { SignUpSwitch, SignUpSwitchProps } from './SignUpSwitch'

export * from './fragments'

export type State = {
  user: Maybe<User>
  code?: string
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSignUp: SignUpArtistFormProps['onSignUp']
  onSignUpWithApple: SignUpArtistFormProps['onSignUpWithApple']
  onSignUpWithGoogle: SignUpArtistFormProps['onSignUpWithGoogle']
  onSignUpWithTwitter: SignUpArtistFormProps['onSignUpWithTwitter']
  onSignUpSwitch: SignUpSwitchProps['onSignUpSwitch']
}

export const SignUpArtistTemplate: Template<State, Action> = ({
  state,
  onSignUp,
  onSignUpWithApple,
  onSignUpWithGoogle,
  onSignUpWithTwitter,
  onSignUpSwitch,
}) => {
  const { t } = useTranslation('signUpArtist')
  const { routerNames } = useRouter()

  return (
    <>
      <Head title={routerNames.SignUpArtist} />
      <BaseLayout
        header={{
          title: t('title'),
          back: true,
        }}
      >
        <StorageImage width="100%" src="images/login/artist_explanation.png" />
        <HeadingTextCell />
        {state.user ? (
          <SignUpSwitch onSignUpSwitch={onSignUpSwitch} />
        ) : (
          <SignUpArtistForm
            invitationCode={state.code}
            onSignUp={onSignUp}
            onSignUpWithApple={onSignUpWithApple}
            onSignUpWithGoogle={onSignUpWithGoogle}
            onSignUpWithTwitter={onSignUpWithTwitter}
          />
        )}
      </BaseLayout>
    </>
  )
}

const HeadingTextCell: Cell = () => {
  const { t } = useTranslation('signUpArtist')
  return (
    <CellFrame sx={{ py: 2, px: 5 }}>
      <Typography variant="h3">{t('artistRegisterScreen')}</Typography>
    </CellFrame>
  )
}
